import { c as _c } from "react/compiler-runtime";
import { ContactFiledInterface, ContactSlugEnum, CountryEnum, FormInput, FormInputPhone, FormSelect, Tooltip, getContactFieldTitle, getContactSlugName, getCountryData } from '@systemeio/ui';
import { deleteField } from 'modules/contacts/contact-page/api/contact-edit-api';
import { ContactFieldApiInterface } from 'modules/contacts/types/contact-filter-interface';
import { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { KeyedMutator } from 'swr';
import { BinIcon } from '@systemeio/ui/icons';
interface ContactEditFieldProps {
  field: ContactFiledInterface;
  value: string | undefined;
  onChange: (value?: string) => void;
  className?: string;
  mutateFields?: KeyedMutator<ContactFieldApiInterface>;
  type: 'create' | 'edit';
  error?: string;
}
const ContactFields = t0 => {
  const $ = _c(41);
  const {
    field,
    onChange,
    className,
    value,
    mutateFields,
    type,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== field) {
    t1 = getContactFieldTitle(field);
    $[0] = field;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contactFieldTitle = t1;
  let t2;
  if ($[2] !== mutateFields) {
    t2 = async id => {
      if (typeof mutateFields === "undefined") {
        return;
      }
      await deleteField(id);
      await mutateFields(data => {
        if (data) {
          return {
            ...data,
            items: [...data.items.filter(el => el.id !== id)]
          };
        }
      }, false);
    };
    $[2] = mutateFields;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onDeleteField = t2;
  switch (field.slug) {
    case ContactSlugEnum.Country:
      {
        let t3;
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = getContactSlugName(ContactSlugEnum.Country);
          t4 = getContactSlugName(ContactSlugEnum.Country);
          $[4] = t3;
          $[5] = t4;
        } else {
          t3 = $[4];
          t4 = $[5];
        }
        const t5 = user?.dashboardLocale;
        let t6;
        if ($[6] !== t5) {
          t6 = getCountryData(t5);
          $[6] = t5;
          $[7] = t6;
        } else {
          t6 = $[7];
        }
        const t7 = value as CountryEnum;
        let t8;
        if ($[8] !== className || $[9] !== error || $[10] !== onChange || $[11] !== t6 || $[12] !== t7) {
          t8 = <FormSelect containerClassName={className} label={t3} placeholder={t4} data={t6} value={t7} onChange={onChange} error={error} />;
          $[8] = className;
          $[9] = error;
          $[10] = onChange;
          $[11] = t6;
          $[12] = t7;
          $[13] = t8;
        } else {
          t8 = $[13];
        }
        return t8;
      }
    case ContactSlugEnum.PhoneNumber:
      {
        let t3;
        let t4;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = getContactSlugName(ContactSlugEnum.PhoneNumber);
          t4 = getContactSlugName(ContactSlugEnum.PhoneNumber);
          $[14] = t3;
          $[15] = t4;
        } else {
          t3 = $[14];
          t4 = $[15];
        }
        let t5;
        if ($[16] !== className || $[17] !== error || $[18] !== onChange || $[19] !== value) {
          t5 = <FormInputPhone wrapperClassName={className} label={t3} placeholder={t4} value={value} onChange={onChange} error={error} />;
          $[16] = className;
          $[17] = error;
          $[18] = onChange;
          $[19] = value;
          $[20] = t5;
        } else {
          t5 = $[20];
        }
        return t5;
      }
    default:
      {
        const t3 = field.slug === ContactSlugEnum.Email && type === "create";
        const t4 = field.slug === ContactSlugEnum.Email && type === "edit";
        let t5;
        if ($[21] !== onChange) {
          t5 = e => onChange(e.target.value);
          $[21] = onChange;
          $[22] = t5;
        } else {
          t5 = $[22];
        }
        const t6 = field.slug !== ContactSlugEnum.Email ? "w-full" : "";
        let t7;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = {
            htmlFor: "none"
          };
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== contactFieldTitle || $[25] !== field.id || $[26] !== field.slug || $[27] !== onDeleteField || $[28] !== opened || $[29] !== t) {
          t8 = Object.values(ContactSlugEnum).includes(field.slug as ContactSlugEnum) ? contactFieldTitle : <div className="flex w-full justify-between">{contactFieldTitle}<Tooltip mode="hover" label={t("dashboard.contact_page.delete_contact_field")}><button onClick={() => setOpened(true)} className="group outline-hidden"><BinIcon className="main-transition-colors group-hover:fill-danger group-focus-visible:fill-danger h-[20px] w-[20px]" /></button></Tooltip><ConfirmationModal confirmationText={t("dashboard.contact_page.delete_contact_field_description")} toastCaption={t("dashboard.contact_page.field_removed")} opened={opened} onClose={() => setOpened(false)} onConfirm={() => onDeleteField(field.id)} /></div>;
          $[24] = contactFieldTitle;
          $[25] = field.id;
          $[26] = field.slug;
          $[27] = onDeleteField;
          $[28] = opened;
          $[29] = t;
          $[30] = t8;
        } else {
          t8 = $[30];
        }
        let t9;
        if ($[31] !== className || $[32] !== contactFieldTitle || $[33] !== error || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== t8 || $[39] !== value) {
          t9 = <FormInput required={t3} disabled={t4} className={className} value={value} error={error} onChange={t5} labelClassName={t6} nativeLabelProps={t7} label={t8} placeholder={contactFieldTitle} />;
          $[31] = className;
          $[32] = contactFieldTitle;
          $[33] = error;
          $[34] = t3;
          $[35] = t4;
          $[36] = t5;
          $[37] = t6;
          $[38] = t8;
          $[39] = value;
          $[40] = t9;
        } else {
          t9 = $[40];
        }
        return t9;
      }
  }
};
export default ContactFields;